<template>
    <div class="mindmap-collect">
        <div class="nav-menu" v-show="showAvatarMenu">
            <div class="nav-title">{{ profile.name }}</div>
            <div class="nav-title" v-show="isCollectCreator">{{ $t("mindmap.fluidRelayUsage") }}{{ currentOpenFRUsage }}/{{ maxOpenFRUsage }}</div>
            <div class="nav-item" @click="logout">{{ $t("mindmap.logout") }}</div>
        </div>
        <div class="actions" v-show="showActionMenu"
            :style="{ left: actionMenuPos.x + 'px', top: actionMenuPos.y + 'px' }">
            <div class="action-item" @click="showLinkMsg()">{{ $t("mindmap.mindCollectPage.viewURL") }}</div>
            <div class="action-item" v-if="isCollectCreator" @click="showEditKeyMsg()">{{ $t("mindmap.mindCollectPage.viewEditKey") }}</div>
            <div class="action-item" v-if="isCollectCreator && !isCurrentMindMapTemplate()" @click="confirmDeleteMindMap()">{{ $t("mindmap.mindCollectPage.deleteMindMap") }}</div>
        </div>
        <div class="search-box" v-show="showSearchBox">
            <!--搜尋-->
            <div class="search-wrap" >
                <div class="back-btn" @click="closeSearchBox()">
                    <svg-icon icon-class="arrow-pre" />
                </div>    
                  
                <label class="search-bar">
                    <input :placeholder="$t('mindmap.mindmapHome.search')" v-model="search" />
                    <div class="delete-btn" v-show="search.length !== 0" @click="resetSearch()">
                        <svg-icon icon-class="close" />
                    </div>
                    <button type="submit" class="search-btn" @click="searchMindMaps()"
                        :disabled="search.length == 0">
                        <svg-icon icon-class="search" class="search-icon" />
                    </button>
                </label>
            </div>
            <!--搜尋End-->
        </div>
        <div v-show="showComfirmDelete" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="closeComfirmDelete()"></svg-icon></div>
                <div class="shareCard-title">{{ $t("mindmap.mindmapHome.confirmDelete") }}{{ currentMindMap.mindmapName }}</div>
                <div>{{ $t("mindmap.mindmapHome.comfirmDelete") }}</div>
                <div class="temp-btn danger-btn" @click="deleteSingleMindMap()">{{ $t("mindmap.確定") }}</div>
                <div class="temp-btn gray-btn" @click="closeComfirmDelete()">{{ $t("mindmap.取消") }}</div>
            </div>
        </div>

        <div v-show="showMindForm" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="showMindForm = false"></svg-icon></div>
                <div class="shareCard-title">{{ $t("mindmap.mindCollectPage.submitMindMap") }}</div>
                <div>
                    <label class="input-wrap">
                        <div class="input-title">{{ $t("mindmap.mindCollectPage.seatNum") }}</div>
                        <input :placeholder="$t('mindmap.mindCollectPage.inputNum')" maxlength="3" type="text"
                            v-model="stuSeatNumber" @input="validateNumberInput">
                    </label>
                    <label class="input-wrap">
                        <div class="input-title">{{ $t("mindmap.mindCollectPage.name") }}</div><input :placeholder="$t('mindmap.mindCollectPage.inputName')" v-model="stuName" maxlength="20"
                            type="text">
                    </label>
                    <label class="input-wrap">
                        <div class="input-title">{{ $t("mindmap.mindCollectPage.topic") }}</div>
                        <input :placeholder="mindcollectName || $t('mindmap.mindCollectPage.newTopic')" v-model="stuTopic" maxlength="20" type="text">
                    </label>
                </div>

                <div class="save-btn" v-show="stuSeatNumber != '' && stuName !== ''" @click="confirmToCreate()">
                    {{ $t("mindmap.確定") }}</div>
            </div>
        </div>

        <div class="view-btn search-btn-mid"  :class="{ 'search-btn-mid-down': !isLogin }"  @click="openSearchBox()">
                    <svg-icon icon-class="search"  class="search-icon"/>
        </div>

        <div class="flex-bar">
            <div class="left">
                <div class="title"><svg-icon iconClass="hi-mind"></svg-icon><span class="title-text">{{ $t("mindmap.productName") }}</span></div>
            </div>
            <div class="right">
                <div v-if="!isLogin" @click="loginTMID()" class="controls profile-btn">
                    <svg-icon iconClass="profile" class="profile-icon" />
                </div>

                <div class="controls refresh-btn" v-show="isCollectCreator" @click="refreshMindCollectData()">
                    <svg-icon icon-class="refresh" />
                </div>

                <div class="avatar-wrap" v-if="isLogin" @click="showAvatarMenu = !showAvatarMenu"><img class="avatar"
                        :src="profile.picture" alt="" /></div>
            </div>
        </div>
        <!--listView-->
        <div class="mindmap-list" v-show="currentView == 'list'">
            <div class="top-flex" v-show="!showSearchBox">
                <div class="left">
                    <div class="title"><span class="home-link" v-if="isCollectCreator" @click="goHome()"><svg-icon icon-class="arrow-pre" /></span>
                        <svg-icon icon-class="task" class="task-icon" /><span class="title-text" @click="handleTitleClick()">{{ displayMindCollectName }}</span></div>
                </div>
                <div class="right">
                    <div @click="openCreateMindForm()" class="temp-btn submit-task-btn" v-show="mindCollect.openSubmit && !isCollectCreator">+ {{$t("mindmap.mindCollectPage.submitMindMap")}}</div>
                    <div v-if="!isLogin && currentMindMapURL" class="temp-btn clip-code-display-btn" @click="copyShortUrl()">
                        <svg-icon icon-class="link" class="link-icon" />{{ currentMindMapURL }}
                    </div>
                    <div @click="createReferMindMap()" class="temp-btn" v-show="isCollectCreator">+ {{$t("mindmap.mindCollectPage.createRefer")}}</div>
                    <label class="switch " v-show="isCollectCreator">
                        <input type="checkbox" v-model="useTemplate">
                        <span class="slider round"></span>
                    </label>
                    <span class="switch-text" v-show="isCollectCreator">{{$t("mindmap.mindCollectPage.useTemplate")}}</span>
                    <div class="temp-btn share-btn" v-show="isLogin && isCollectCreator" @click="handleTitleClick()"><svg-icon icon-class="link" class="link-icon" />{{ $t('mindmap.mindmapHome.mindCollect.share') }}</div>
                    <!--搜尋-->
                    <div class="search-wrap">
                        <label class="search-bar">
                            <input :placeholder="$t('mindmap.mindCollectPage.searchTopic')" v-model="search" />
                            <div class="delete-btn" v-show="search.length !== 0" @click="resetSearch()">
                                <svg-icon icon-class="close" />
                            </div>
                            <button type="submit" class="search-btn" @click="searchMindMaps()"
                                :disabled="search.length == 0">
                                <svg-icon icon-class="search" class="search-icon" />
                            </button>
                        </label>
                    </div>
                    <div class="view-btn" :class="{ 'active-btn': currentView == 'list' }" @click="setView('list')">
                        <svg-icon icon-class="list" />
                    </div>
                    <div class="view-btn" :class="{ 'active-btn': currentView == 'grid' }" @click="setView('grid')">
                        <svg-icon icon-class="grid" />
                    </div>
                </div>
            </div>
            <div class="list-wrap">
                <table v-if="mindmapList != null">
                    <thead>
                        <tr>
                            <th @click="getMyMindMapListBySort('mindSubCreator.id')">{{ $t('mindmap.mindCollectPage.seatNum') }} <span
                                    v-show="currentSortField == 'mindSubCreator.id'">{{ currentSortOrder == 'asc' ? '↓' :
                                    '↑' }}</span></th>
                            <th @click="getMyMindMapListBySort('mindSubCreator.name')">{{ $t('mindmap.mindCollectPage.name') }} <span
                                    v-show="currentSortField == 'mindSubCreator.name'">{{ currentSortOrder == 'asc' ? '↓' :
                                    '↑' }}</span></th>
                            <th @click="getMyMindMapListBySort('mindmapName')">{{ $t('mindmap.mindCollectPage.topic') }} <span
                                    v-show="currentSortField == 'mindmapName'">{{ currentSortOrder == 'asc' ? '↓' :
                                    '↑' }}</span></th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="mindmap in mindmapList" :key="mindmap.id" v-show="mindmap.isDeleting == false && (isCollectCreator || mindmap.id !== mindCollect.collectReferMindId)">
                            <td @click="openMindMapByID(mindmap)">
                                {{ mindmap.mindSubCreator.id }}
                            </td>
                            <td @click="openMindMapByID(mindmap)">
                                {{ mindmap.mindSubCreator.name }}
                            </td>

                            <td @click="openMindMapByID(mindmap)">{{ mindmap.mindmapName }}</td>
                            <td>
                                <div class="more-btn" @click="openActionMenu(mindmap, $event)"><svg-icon iconClass="more"></svg-icon></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="text-md ml-5 mt-5 font-bold" v-if="mindmapList.length == 0">
                    {{ $t("mindmap.mindmapHome.noData") }}
                </div>
            </div>

        </div>
        <!--gridView，部分樣式沿用教師上傳教材網Taiwind-->
        <div class="mindmap-grid" v-show="currentView == 'grid'">
            <div class="top-flex" v-show="!showSearchBox">
                <div class="left">
                    <div class="title"><span class="home-link" v-if="isCollectCreator" @click="goHome()"><svg-icon icon-class="arrow-pre" /></span>
                        <svg-icon icon-class="task" class="task-icon" /><span class="title-text" @click="handleTitleClick()">{{ displayMindCollectName }}</span></div>
                </div>
                <div class="right">
                    <div @click="openCreateMindForm()" class="temp-btn submit-task-btn" v-show="mindCollect.openSubmit && !isCollectCreator">+ {{$t("mindmap.mindCollectPage.submitMindMap")}}</div>
                    <div v-if="!isLogin && currentMindMapURL" class="temp-btn clip-code-display-btn" @click="copyShortUrl()">
                        <svg-icon icon-class="link" class="link-icon" />{{ currentMindMapURL }}
                    </div>
                    <div @click="createReferMindMap()" class="temp-btn" v-show="isCollectCreator">+ {{$t("mindmap.mindCollectPage.createRefer")}}</div>
                    <label class="switch " v-show="isCollectCreator">
                        <input type="checkbox" v-model="useTemplate">
                        <span class="slider round"></span>
                    </label>
                    <span class="switch-text" v-show="isCollectCreator">{{$t("mindmap.mindCollectPage.useTemplate")}}</span>
                    <div class="temp-btn share-btn" v-show="isLogin && isCollectCreator" @click="handleTitleClick()"><svg-icon icon-class="link" class="link-icon" />{{ $t('mindmap.mindmapHome.mindCollect.share') }}</div>
                    <!--搜尋-->
                    <div class="search-wrap">
                        <label class="search-bar">
                            <input :placeholder="$t('mindmap.mindCollectPage.searchTopic')" v-model="search" />
                            <div class="delete-btn" v-show="search.length !== 0" @click="resetSearch()">
                                <svg-icon icon-class="close" />
                            </div>
                            <button type="submit" class="search-btn" @click="searchMindMaps()"
                                :disabled="search.length == 0">
                                <svg-icon icon-class="search" class="search-icon" />
                            </button>
                        </label>
                    </div>
                    <div class="view-btn" :class="{ 'active-btn': currentView == 'list' }" @click="setView('list')">
                        <svg-icon icon-class="list" />
                    </div>
                    <div class="view-btn" :class="{ 'active-btn': currentView == 'grid' }" @click="setView('grid')">
                        <svg-icon icon-class="grid" />
                    </div>
                </div>
            </div>
            <div class="mindmapcard-wrap" v-if="mindmapList.length > 0">
                <div class="card-item" v-for="mindmap in mindmapList" :key="mindmap.id" v-show="mindmap.isDeleting == false && (isCollectCreator || mindmap.id !== mindCollect.collectReferMindId)">
                    <div class="img-top" @click="openMindMapByID(mindmap)"  v-lazy-background="getMindMapImgUrl(mindmap)" />
                    <div class="card-textwrap">
                        <h5 @click="openMindMapByID(mindmap)">{{ mindmap.mindmapName }}</h5>
                        <p class="seat-num">{{ $t('mindmap.mindCollectPage.seatNum') }}: {{ mindmap.mindSubCreator.id }}</p>
                        <p class="student-name">{{ $t('mindmap.mindCollectPage.name') }}: {{ mindmap.mindSubCreator.name }}</p>
                    </div>
                    <div class="more-btn" @click="openActionMenu(mindmap, $event)">
                        <svg-icon icon-class="more" />
                    </div>
                </div>
            </div>
            <div class="text-md ml-8 mt-8 font-bold" v-else>
                {{ $t("mindmap.mindmapHome.noData") }}
            </div>
        </div>

        <!---MindCollect--->
        <div v-show="showUpdateMindCollectSetting && !showQRCodeCard" class="shareCard-wrap">
            <div class="shareCard">
                <div class="close-btn"> <svg-icon iconClass="close" @click="confirmToUpdateMindCollect()"></svg-icon>
                </div>
                <div class="shareCard-title">{{ $t('mindmap.mindmapHome.mindCollect.updateSetting') }}</div>
                <div class="shareCard-content">
                    <div class="rename-wrap">
                        <label class="rename-bar">
                            <input :placeholder="currentMindCollectName" v-model="renameMindCollectVal"
                                maxlength="20" />
                            <div class="delete-btn" v-show="renameMindCollectVal.length !== 0"
                                @click="resetMindCollectName()">
                                <svg-icon icon-class="close" />
                            </div>
                        </label>
                    </div>
                </div>
                <div class="flex-container">
                    <div class="flex-item">{{ $t("mindmap.mindmapHome.mindCollect.openSummitTitle") }}</div>
                    <label class="switch flex-item">
                        <input type="checkbox" v-model="isMindCollectSubmitOpen">
                        <span class="slider round"></span>
                    </label>

                </div>

                <div class="flex-container">

                    <div class="flex-item">{{ $t("mindmap.mindmapHome.mindCollect.allowViewTitle") }}</div>
                    <label class="switch flex-item">
                        <input type="checkbox" v-model="isMindCollectAllowView">
                        <span class="slider round"></span>
                    </label>
                </div>
                <div class="url-wrap url-wrap-small"><span class="url-title">URL：</span>{{ shortURLHost }}<span
                        class="short-url">{{
        currentMindMapURL }}
                    </span>
                    <span class="copy-btn" @click="copyShortUrl()"><svg-icon icon-class="copy" /></span>
                    <span class="copy-btn" @click="openQRCode(shortURLHost + currentMindMapURL)"><svg-icon icon-class="qrcode-new" /></span>
                    <span v-if="shouldShowPushButton" class="push-button"
                                          :class="{ 'disabled': isSendDisabled }"
                                          @click="handleSendClick()">
                       <svg-icon icon-class="upload" class="sendweb-icon" />
                    </span>
                </div>

                <!-- Tips 提示區塊 -->
                <div class="tips-container">
                    <div class="tips-text">{{ $t("mindmap.mindCollectPage.templateTips") }}</div>
                </div>
            </div>
        </div>
    </div>

    <!-- QR Code Dialog -->
    <QRCodeDialog v-if="showQRCodeCard" :url="qrCodeUrl" :short-code="currentMindMapURL" :short-u-r-l-host="shortURLHost" @close="closeQRCode" />
</template>

<script setup>
/*eslint-disable*/
import SvgIcon from "@/components/SvgIcon.vue";
import { toRaw, ref, onMounted, getCurrentInstance, reactive, inject, onBeforeUnmount, watch, computed } from "vue";
import QRCodeDialog from "@/components/QRCodeDialog.vue";
import api from "@/api";
import { jsFn } from "@/utils/jsFn";
import { SharedMap } from "fluid-framework";
import { AzureClient } from "@fluidframework/azure-client";
import { useRouter } from 'vue-router';
import { useMainStore } from '@/stores/mainStore';
import { useMindMapStore } from "@/stores/mindMapStore";
import { BlobServiceClient } from "@azure/storage-blob";
import { useQuasar } from 'quasar'

import jwt_decode from "jwt-decode";
import main from "@/api/main";
import confProfile from "@/api/profile";
var serverLocation = main.getServerLocation();

let that = getCurrentInstance().proxy;

let historyUpdateInterval = null;
const $Message = inject("$Message");

const router = useRouter();
const store = useMainStore();
const mindMapStore = useMindMapStore();
const $q = useQuasar()

const mindmapList = ref([]);
const mindCollect = ref({});
const mindcollectName = ref("");
const isLogin = ref(false);
const showSearchBox = ref(false);
const search = ref("");
const currentView = ref("list");
const currentPageNum = ref(1);
const pageBtns = ref([]);
const isCollectCreator = ref(false);
const profile = reactive({
    name: "",
    teammodelId: "",
    picture: "",
});
const currentSortField = ref("mindSubCreator.id");
const currentSortOrder = ref("asc");
const currentMindMap = ref({});
const currentOpenFRUsage = ref(0); //開放分享的fluidrelay 之計算，只要沒有開放分享就不計在用量
const maxOpenFRUsage = ref(100); //開放分享的fluidrelay 之上限  
const isReachMaxOpenFRUsage = ref(false);

const actionMenuPos = reactive({
    x: 0,
    y: 0,
});
const showMindForm = ref(false); //在作業區創建mindmap
const showAvatarMenu = ref(false);
const showActionMenu = ref(false);
const showComfirmDelete = ref(false);

const stuSeatNumber = ref("");
const stuName = ref("");
const stuTopic = ref("");
const useTemplate = ref(false); // 新增的資料綁定
const showUpdateMindCollectSetting = ref(false);

// MindCollect設置相關變數
const currentMindCollectName = ref("");
const renameMindCollectVal = ref("");
const isMindCollectSubmitOpen = ref(false);
const isMindCollectAllowView = ref(false);
const shortURLHost = ref(confProfile.shortUrlHost[serverLocation]);
const currentMindMapURL = ref("");

// 推送按鈕相關
const isSendDisabled = ref(false);
const cooldownTimer = ref(null);

// 計算屬性：動態顯示標題，支援即時編輯同步
const displayMindCollectName = computed(() => {
    if (showUpdateMindCollectSetting.value && renameMindCollectVal.value && renameMindCollectVal.value.trim() !== '') {
        return renameMindCollectVal.value;
    }
    return mindcollectName.value;
});

const containerSchema = reactive({
    initialObjects: {
        mindHistory: SharedMap,
        mindData: SharedMap,
        isDeleting: SharedMap,
        coworkMode: SharedMap,
    },
});

let fluidIsDeleting = reactive({});
let fluidCoworkMode = reactive({});

let referMindMapData = reactive({});
let referFid = ref("");

const enterMindHistory = reactive({});

// 設定使用者認證資訊（從WebView接收）
const setupUserAuth = (parameters) => {
    if (parameters.access_Token && parameters.id_Token) {
        const decoded = jwt_decode(parameters.id_Token);
        const profileData = {
            name: decoded.name,
            teammodelId: decoded.sub,
            picture: decoded.picture,
        };
        
        localStorage.setItem("access_token", parameters.access_Token);
        localStorage.setItem("id_token", parameters.id_Token);
        localStorage.setItem("expires_in", parameters.expires_in);
        localStorage.setItem("profile", JSON.stringify(profileData));
        sessionStorage.setItem("jumpFrom", "HT");
        
        // 同步更新當前頁面狀態
        profile.name = profileData.name;
        profile.picture = profileData.picture;
        profile.teammodelId = profileData.teammodelId;
        isLogin.value = true;
        
        console.log("用戶認證已更新:", profileData);
    }
};

function goHome() {
    router.push("/MindMapHome");
}

const openSearchBox = () => {
    showSearchBox.value = true;
}    

const closeSearchBox = () => {
    showSearchBox.value = false;
    resetSearch();
}   


const loginTMID = () => {
    api.main.loginTmdID();
};

const handleAvatarClickOutside = (event) => {
    if (!event.target.closest(".nav-menu") && !event.target.closest(".avatar")) {
        showAvatarMenu.value = false;
    }
};

const openActionMenu = (mindmap, e) => {
    currentMindMap.value = mindmap;
    showActionMenu.value = true
    actionMenuPos.x = e.clientX - 120
    actionMenuPos.y = e.clientY -10
    console.log("currentMindMap:", toRaw(currentMindMap.value));

    // 點擊其他地方關閉菜單
    const closeMenu = (e) => {
        if (!e.target.closest('.action-menu') && !e.target.closest('.more-btn')) {
            showActionMenu.value = false;
            document.removeEventListener('click', closeMenu);
        }
    };
    setTimeout(() => {
        document.addEventListener('click', closeMenu);
    }, 0);
}

const showEditKeyMsg = () => {
    $Message.info({
        content: that.$t("mindmap.mindCollectPage.editKey")+'<strong>'+jsFn.decrypt(currentMindMap.value.mindSubCreatorEditKey)+'<strong>',
        duration: 5,
        closable: true,
    });
};

const showLinkMsg = () => {
    $Message.info({
        content: that.$t("mindmap.mindCollectPage.url")+'<strong>'+window.location.origin + '/MindMapClone?id=' + currentMindMap.value.id+'<strong>',
        duration: 5,
        closable: true,
    });
}

const isCurrentMindMapTemplate = () => {
    // 檢查當前選中的心智圖是否為範本
    return currentMindMap.value.id === mindCollect.value.collectReferMindId;
}

const confirmDeleteMindMap = () => {
    showActionMenu.value = false;
    showComfirmDelete.value = true;
}

const closeComfirmDelete = () => {
    showComfirmDelete.value = false;
}

const deleteSingleMindMap = async () => {
    try {
        showComfirmDelete.value = false;

        $q.loading.show({
            message: that.$t("mindmap.mindmapHome.delete") + '...'
        });

        const data = {
            id: currentMindMap.value.id
        };

        await api.mindmapAPI.deleteMindMap(data);

        // 從列表中移除已刪除的心智圖
        mindmapList.value = mindmapList.value.filter(m => m.id !== currentMindMap.value.id);

        $Message.success(that.$t("mindmap.mindmapHome.delete") + ' ' + that.$t("mindmap.mindmapHome.saveOk"));

        // 重新整理列表以更新 FluidRelay 用量
        await refreshMindCollectData();
    } catch (error) {
        console.error("刪除失敗:", error);
        $Message.error(that.$t("mindmap.mindmapHome.delete") + ' ' + that.$t("mindmap.mindmapHome.saveFailed"));
    } finally {
        $q.loading.hide();
    }
}

// 重置MindCollect名稱
const resetMindCollectName = () => {
    renameMindCollectVal.value = currentMindCollectName.value
}

// 複製短網址
// QR Code
const showQRCodeCard = ref(false);
const qrCodeUrl = ref('');
const openQRCode = (url) => {
    qrCodeUrl.value = url;
    showQRCodeCard.value = true;
};
const closeQRCode = () => { showQRCodeCard.value = false; };

const copyShortUrl = () => {
    const url = shortURLHost.value + currentMindMapURL.value;
    const input = document.createElement('input');
    input.value = url;
    document.body.appendChild(input);
    input.select();
    document.execCommand('Copy');
    document.body.removeChild(input);
    $Message.info(that.$t("mindmap.mainMenu.alreadyCopied"));
}

// WebView 檢查
const isWebView = computed(() => {
   return window?.chrome?.webview || false;
});

// ========== 新增：判斷是否應該顯示推送按鈕（WebView 或 iframe） ==========
const shouldShowPushButton = computed(() => {
  const isInIframe = window.self !== window.top;
  return isWebView.value || isInIframe;
});
// ========== 新增結束 ==========

// 推送按鈕點擊處理
const handleSendClick = () => {
    console.log('按鈕點擊，當前禁用狀態：', isSendDisabled.value);

    if (isSendDisabled.value) {
        $Message.warning({
            content: that.$t('mindmap.mindCollectLinkShareCooldown'),
            duration: 3,
            closable: true
        });
        return;
    }

    // 執行推送
    sendToWebIRS();
    $Message.success({
        content: that.$t('mindmap.mindCollectLinkShareSuccess'),
        duration: 3,
        closable: true
    });

    // 設置冷卻狀態
    isSendDisabled.value = true;
    console.log('設置為禁用狀態：', isSendDisabled.value);

    // 清除舊的 timer（如果存在）
    if (cooldownTimer.value) {
        clearTimeout(cooldownTimer.value);
    }

    // 1分鐘後恢復
    cooldownTimer.value = setTimeout(() => {
        isSendDisabled.value = false;
        console.log('恢復為啟用狀態：', isSendDisabled.value);
        cooldownTimer.value = null; // 清除 timer 引用
    }, 60000); // 60秒
};

const sendToWebIRS = () => {
    if (window?.chrome?.webview) {
        window?.chrome?.webview.postMessage({
            action: 'SendMindCollectLink.WebIRS',
            data:{
                url: shortURLHost.value + currentMindMapURL.value,
            }
        });
        console.log('SendMindCollectLink.WebIRS', {
            action: 'SendMindCollectLink.WebIRS',
            data:{
                url: shortURLHost.value + currentMindMapURL.value,
            }
        });
    }

    // ========== 新增：iframe 模式支援 ==========
    const isInIframe = window.self !== window.top;
    if (isInIframe) {
        const message = {
            action: 'SendMindCollectLink.WebIRS',
            data:{
                url: shortURLHost.value + currentMindMapURL.value,
            }
        };
        window.parent.postMessage(message, '*');
        console.log('[MindCollect] [iframe] 發送 SendMindCollectLink.WebIRS:', message);
    }
    // ========== 新增結束 ==========
}

// 確認更新MindCollect設置
const confirmToUpdateMindCollect = async () => {
    try {
        const data = {
            "cid": mindCollect.value.id,
            "mindCollectName": renameMindCollectVal.value.length !== 0 ? renameMindCollectVal.value : currentMindCollectName.value,
            "editor": {
                "id": profile.teammodelId,
                "name": profile.name,
            },
            "openSubmit": isMindCollectSubmitOpen.value,
            "allowViewOthers": isMindCollectAllowView.value,
        };
        
        await api.mindmapAPI.updateMindCollect(data);
        
        // 更新本地資料
        mindCollect.value.mindCollectName = data.mindCollectName;
        mindCollect.value.openSubmit = data.openSubmit;
        mindCollect.value.allowViewOthers = data.allowViewOthers;
        mindcollectName.value = data.mindCollectName;
        currentMindCollectName.value = data.mindCollectName;
        
        showUpdateMindCollectSetting.value = false;
        $Message.success(that.$t("mindmap.mindmapHome.saveOk"));
    } catch (error) {
        console.error("儲存失敗：", error);
        $Message.error(that.$t("mindmap.mindmapHome.saveFailed"));
    }
}

// 檢查簡碼有效性並自動重新生成的函數
const checkAndRefreshClipCodeIfNeeded = async (mindCollectData) => {
    if (!mindCollectData || !mindCollectData.urlClipCode) {
        return;
    }

    const now = Date.now();
    const ninetyDaysInMs = 90 * 24 * 60 * 60 * 1000; // 90天的毫秒數
    
    // 檢查是否有 urlClipCodeUpdateTime，如果沒有或超過90天，則檢查簡碼有效性
    if (!mindCollectData.urlClipCodeUpdateTime || (now - mindCollectData.urlClipCodeUpdateTime) > ninetyDaysInMs) {
        try {
            const checkData = { clipCode: mindCollectData.urlClipCode };
            await api.mindmapAPI.getOrigDataFromClipCode(checkData);
            // 簡碼仍有效，不需重新生成
        } catch (error) {
            if (error.response?.status === 404) {
                // 簡碼已失效，重新生成
                await autoRefreshClipCode(mindCollectData);
            } else {
                console.error("檢查簡碼時發生錯誤:", error);
            }
        }
    }
};

// 自動重新生成簡碼的函數
const autoRefreshClipCode = async (mindCollectData) => {
    try {
        // 獲取新的簡碼
        const currentMindMapURL = `${location.origin}/mindcollect?cid=${mindCollectData.id}`;
        const dataForClip = {
            "origDataList": [{ "origData": currentMindMapURL }],
            "type": "mindmap",
            "useShortDigits": false,
            "isPermanent": false,
            "lang": that.$i18n.locale.toLowerCase(),
            "note": JSON.stringify({mindCollectName: mindCollectData.mindCollectName})
        };
        const clipRes = await api.mindmapAPI.getClipCode(dataForClip);
        const newClipCode = clipRes.clipCodePairs[0].clipCode;

        // 更新心智圖收集的簡碼
        const updateData = {
            cid: mindCollectData.id,
            editor: {
                id: mindCollectData.editor ? mindCollectData.editor.id : profile.teammodelId,
                name: mindCollectData.editor ? mindCollectData.editor.name : profile.name
            },
            urlClipCode: newClipCode,
        };
        await api.mindmapAPI.updateMindCollect(updateData);
        
        // 更新本地資料
        mindCollectData.urlClipCode = newClipCode;
        mindCollectData.urlClipCodeUpdateTime = Date.now();
        currentMindMapURL.value = newClipCode;
        
        console.log("簡碼已自動更新:", newClipCode);
        
    } catch (error) {
        console.error("自動重新獲取簡碼失敗:", error);
    }
};

// 檢查是否需要顯示簡碼更新提示
const checkAndShowClipCodeUpdateNotice = (mindCollectData) => {
    if (!mindCollectData || !mindCollectData.urlClipCodeUpdateTime || !mindCollectData.createTime) {
        return;
    }

    // 檢查此 session 是否已經顯示過此 mindCollect 的提醒
    const sessionKey = `clipCodeNoticeShown_${mindCollectData.id}`;
    if (sessionStorage.getItem(sessionKey)) {
        return; // 此 session 已顯示過，不再顯示
    }

    const now = Date.now();
    const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000; // 7天的毫秒數
    const createTimeMs = mindCollectData.createTime * 1000; // createTime 是秒，轉換為毫秒
    const updateTime = mindCollectData.urlClipCodeUpdateTime;

    // 檢查是否是最近更新的（7天內），且不是創建時的初始簡碼
    // 使用時間差來判斷，容忍5分鐘的誤差
    const timeDiff = Math.abs(updateTime - createTimeMs);
    const fiveMinutesInMs = 5 * 60 * 1000; // 5分鐘的毫秒數

    if ((now - updateTime) <= sevenDaysInMs && timeDiff > fiveMinutesInMs) {
        $Message.warning(that.$t("mindmap.mindmapHome.clipCodeAutoUpdated"));

        // 標記此 session 已顯示過此 mindCollect 的提醒
        sessionStorage.setItem(sessionKey, 'true');
    }
};

const handleTitleClick = async () => {
    if (isCollectCreator.value) {
        await openMindCollectSetting();
    }
};

// 打開設定並檢查簡碼
const openMindCollectSetting = async () => {
    // 檢查並自動更新簡碼（如果超過90天且無效）
    await checkAndRefreshClipCodeIfNeeded(mindCollect.value);

    // 檢查並顯示簡碼更新提示（如果在7天內更新過且不是創建時間）
    checkAndShowClipCodeUpdateNotice(mindCollect.value);

    // 預設帶入目前的標題值
    renameMindCollectVal.value = currentMindCollectName.value;

    showUpdateMindCollectSetting.value = true;
};

const initializeAzureClient = async () => {
    try {
        localStorage.removeItem("cachedFluidRelayToken"); // 初始化先移除 localStorage
        const fluidConfig = await api.mindmapAPI.getFluidRelayConfig();
        let dataCenter = (serverLocation.includes("cn")) ? "china" : "global";
        const serviceConfig = {
            connection: {
                type: "remote",
                tenantId: fluidConfig[dataCenter]?.fluidRelayTenantId,
                tokenProvider: new api.MyAzTokenProvider(api.mindmapAPI.fluidTokenUrl, {
                    "idToken": "",
                    "id": stuSeatNumber.value=="-" ? profile.teammodelId : stuSeatNumber.value ,
                    "name": stuName.value=="teacher" ? profile.name : stuName.value,
                }),
                endpoint: fluidConfig[dataCenter]?.fluidRelayEndpoint,
            },
        };
        return new AzureClient(serviceConfig);
    } catch (error) {
        console.error("初始化 AzureClient 失敗:", error);
        throw error;
    }
};

const genMindSubCreatorKey = () => {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const randomLetters = Array.from({ length: 2 }, () => letters[Math.floor(Math.random() * letters.length)]).join('');
    const randomNumbers = Math.floor(1000 + Math.random() * 9000).toString();

    return `${randomLetters}${randomNumbers}`;
};

const getFluidMindData = async (Fid, isTemplateMode = false) => {
    let retryCount = 0;
    // 模板模式需要更多重試次數
    const maxRetries = isTemplateMode ? 10 : 3;
    const retryDelay = isTemplateMode ? 3000 : 2000; // 模板模式延長延遲時間

    if (isTemplateMode) {
        console.log(`🔄 模板模式：getFluidMindData 將重試最多 ${maxRetries} 次，延遲 ${retryDelay}ms`);
    }

    const tryGetContainer = async () => {
        try {
            const client = await initializeAzureClient();
            // 捕捉 getContainer 操作中的異常
            const result = await client.getContainer(Fid, containerSchema, "2");
            const container = result.container;
            const fluidMindData = container.initialObjects.mindData; //存放markdown資料

            // 檢查資料大小，如果為 0 且是模板模式，需要重試
            const dataSize = fluidMindData?.size || 0;
            console.log(`getFluidMindData 獲取資料大小: ${dataSize}`);

            if (dataSize === 0 && isTemplateMode && retryCount < maxRetries - 1) {
                console.warn(`🚨 [模板模式] 資料大小為 0，這不正常！準備重試 ${retryCount + 1}/${maxRetries}`);
                container.dispose();
                retryCount++;
                console.log(`[模板模式] 等待 ${retryDelay/1000} 秒後重試...`);
                return new Promise(resolve => setTimeout(() => resolve(tryGetContainer()), retryDelay));
            }

            container.dispose();
            return fluidMindData;
        } catch (error) {
            const attemptInfo = isTemplateMode ? `[模板模式] 嘗試 ${retryCount + 1}/${maxRetries}` : `嘗試 ${retryCount + 1}/${maxRetries}`;
            console.error(`${attemptInfo} 失敗:`, error);

            if (isTemplateMode && retryCount === 0) {
                console.warn("🚨 模板模式首次失敗，這可能是容器同步延遲問題");
            }

            $Message.info(that.$t("mindmap.tryingToGetContainer"));
            if (retryCount < maxRetries - 1) {
                retryCount++;
                console.log(`${isTemplateMode ? '[模板模式] ' : ''}等待 ${retryDelay/1000} 秒後重試...`);
                return new Promise(resolve => setTimeout(() => resolve(tryGetContainer()), retryDelay));
            } else {
                const errorMsg = isTemplateMode ? `模板模式已重試 ${maxRetries} 次，仍然失敗` : `已重試 ${maxRetries} 次，仍然失敗`;
                console.error(errorMsg);
                $Message.error(that.$t("mindmap.cannotConnect"));
                return; // 如果無法獲取容器，直接退出
            }
        }
    };

    const result = await tryGetContainer();

    // 最終檢查：如果是模板模式且資料為 0，發出警告
    if (isTemplateMode && (!result || result.size === 0)) {
        console.error(`🚨 [模板模式] getFluidMindData 最終結果資料大小為 0，這可能導致模板複製失敗`);
        console.error(`Container ID: ${Fid}, 重試次數: ${maxRetries}`);
    }

    return result;
}

const createReferMindMap = async () =>{
    console.log("createReferMindMap", toRaw(mindCollect.value));

    //1.獲取資料夾設置看是否有模板
    if(mindCollect.value.collectReferMindId){
       router.push({
            path: '/MindMapClone',
            query: {
                id: mindCollect.value.collectReferMindId,
            },
        });
    }else{
        //1.創建
        stuSeatNumber.value = "-";
        stuName.value = "teacher";

        let data = {
        "mindmapName": stuTopic.value ? stuTopic.value : mindcollectName.value,
        "mindmapCreator": { //已創建收集區者為創建者
            "id": mindCollect.value.creator.id,
            "name": mindCollect.value.creator.name,
        },
        "mindSubCreator": {
            "id": "0",
            "name": "teacher",
        },
        "collectId": mindCollect.value.id,
        "mindSubCreatorEditKey": "",
        "mindmapData": "",
        "fluidContainerId": "",
        "openCowork": false,
        "coworkMode": "view", //需要匿名使用 學生會每次用匿名身份進入，無法用其他模式
    }

    try {
        $Message.info(that.$t("mindmap.mindmapHome.initialize"));
        const client = await initializeAzureClient();


        const { container } = await client.createContainer(containerSchema, "2;");
        data.fluidContainerId = await container.attach();

        fluidIsDeleting = container.initialObjects.isDeleting;
        fluidCoworkMode = container.initialObjects.coworkMode;
        let fluidMindData = container.initialObjects.mindData;

      

        let initMindData = [
            {
                "id": "root",
                "topic": "<p>"+that.$t("mindmap.defaultMind.root")+"</p>",
                "expanded": true,
                "isroot": true,
                "nodeText": that.$t("mindmap.defaultMind.root"),
                "nodeImg": "",
                "nodeLink": "",
                "lock": false
            },
            {
                "id": "uuid1",
                "topic": "<p>"+that.$t("mindmap.defaultMind.node1")+"</p>",
                "expanded": true,
                "parent": {
                    "id": "root"
                },
                "direction": "left",
                "data": {
                    "nodeText": that.$t("mindmap.defaultMind.node1"),
                    "nodeImg": "",
                    "nodeLink": "",
                    "lineColor": "red",
                    "background-color": "rgb(255, 191, 215)",
                    "lock": false
                }
            },
            {
                "id": "uuid2",
                "topic": "<p>"+that.$t("mindmap.defaultMind.node2")+"</p>",
                "expanded": true,
                "parent": {
                    "id": "root"
                },
                "direction": "left",
                "data": {
                    "nodeText": that.$t("mindmap.defaultMind.node2"),
                    "nodeImg": "",
                    "nodeLink": "",
                    "lineColor": "#0000ff",
                    "background-color": "rgb(139, 243, 255)",
                    "lock": false
                }
            },
            {
                "id": "uuid3",
                "topic": "<p>"+that.$t("mindmap.defaultMind.node3")+"</p>",
                "expanded": true,
                "parent": {
                    "id": "root"
                },
                "direction": "right",
                "data": {
                    "nodeText": that.$t("mindmap.defaultMind.node3"),
                    "nodeImg": "",
                    "nodeLink": "",
                    "lineColor": "orange",
                    "background-color": "rgb(255, 238, 139)",
                    "lock": false
                }
            },
            {
                "id": "uuid4",
                "topic": "<p>"+that.$t("mindmap.defaultMind.node4")+"</p>",
                "expanded": true,
                "parent": {
                    "id": "root"
                },
                "data": {
                    "nodeText": that.$t("mindmap.defaultMind.node4"),
                    "nodeImg": "",
                    "nodeLink": "",
                    "lineColor": "green",
                    "background-color": "rgb(211, 255, 139)",
                    "lock": false
                },
                "direction": "right"
            }
        ]
        initMindData.forEach((item) => {
            fluidMindData.set(item.id, JSON.stringify(item));
        })
        


        //初始化先把isDeleting設為false
        fluidIsDeleting.set('data', false);

        fluidCoworkMode.set('data', JSON.stringify({
            "coworkMode": "edit",
            "openCowork": true,
        }));

        const res = await api.mindmapAPI.createMindMap(data);

        //寫入資料夾
        const collectData = {
            "cid": mindCollect.value.id,
            "collectReferMindId": res.id,
            "editor": {
                "id": profile.teammodelId,
                "name": profile.name,
            },
        }
        await api.mindmapAPI.updateMindCollect(collectData);

        // 等待容器資料完全保存到 Fluid 服務
        console.log("createReferMindMap - 等待容器資料保存完成，isDirty:", container.isDirty);
        if (container.isDirty) {
            console.log("createReferMindMap - 容器有未保存的變更，等待 saved 事件...");
            await new Promise((resolve) => {
                container.once("saved", () => {
                    console.log("✅ createReferMindMap - 容器資料已完全保存到 Fluid 服務");
                    resolve();
                });
                // 設定超時保護（10秒）
                setTimeout(() => {
                    console.log("⏰ createReferMindMap - 等待 saved 事件超時，繼續執行");
                    resolve();
                }, 10000);
            });
        } else {
            console.log("✅ createReferMindMap - 容器無未保存變更，直接繼續");
        }

        // 跳轉前斷開當前容器避免下一個頁面連接錯誤
        try {
            if (container && typeof container.dispose === 'function') {
                container.dispose();
            }
        } catch (disposeError) {
            console.warn('容器斷開時發生錯誤，但不影響頁面跳轉:', disposeError);
        }

        router.push({
            path: '/MindMapClone',
            query: {
                id: res.id,
                openCowork: res.openCowork,
            }
        });

    } catch (error) {
        console.error(error);
        $Message.error(that.$t("mindmap.mindmapHome.initializeFailed"));
    }

        
    }
}

const confirmToCreate = async () => {
    showMindForm.value = false;
    $q.loading.show({
        message: that.$t("mindmap.initializeFluidRelay")
    });

    console.log(toRaw(mindCollect.value));

    let encryptedKey = jsFn.encrypt(genMindSubCreatorKey())

    let data = {
        "mindmapName": stuTopic.value ? stuTopic.value : that.$t("mindmap.defaultMind.root"),
        "mindmapCreator": { //已創建收集區者為創建者
            "id": mindCollect.value.creator.id,
            "name": mindCollect.value.creator.name,
        },
        "mindSubCreator": {
            "id": stuSeatNumber.value,
            "name": stuName.value,
        },
        "collectId": mindCollect.value.id,
        "mindSubCreatorEditKey": encryptedKey,
        "mindmapData": "",
        "fluidContainerId": "",
        "openCowork": true,
        "coworkMode": "edit", //需要匿名使用 學生會每次用匿名身份進入，無法用其他模式
    }

    try {
        $Message.info(that.$t("mindmap.mindmapHome.initialize"));
        const client = await initializeAzureClient();


        const { container } = await client.createContainer(containerSchema, "2;");

        fluidIsDeleting = container.initialObjects.isDeleting;
        fluidCoworkMode = container.initialObjects.coworkMode;
        let fluidMindData = container.initialObjects.mindData;

        // 先寫入資料，再 attach 容器
        if (useTemplate.value === true) {
            console.log("開始複製模板資料...");
            const res = await api.mindmapAPI.getMindMapByMid({
                mid: mindCollect.value.collectReferMindId
            });
            referFid.value = res.data.fluidContainerId
            referMindMapData = await getFluidMindData(referFid.value, true); // 傳入 true 表示模板模式
            console.log("獲取最新範本:", referMindMapData);

            if(referMindMapData){
                for (const [key, value] of referMindMapData) {
                    fluidMindData.set(key, value); //全部複製
                }
                console.log("模板資料複製完成，資料大小:", fluidMindData.size);

                // 等待資料同步
                await new Promise(resolve => setTimeout(resolve, 2000));
            }

        } else {

            let initMindData = [
                {
                    "id": "root",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.root") + "</p>",
                    "expanded": true,
                    "isroot": true,
                    "nodeText": that.$t("mindmap.defaultMind.root"),
                    "nodeImg": "",
                    "nodeLink": "",
                    "lock": false
                },
                {
                    "id": "uuid1",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.node1") + "</p>",
                    "expanded": true,
                    "parent": {
                        "id": "root"
                    },
                    "direction": "left",
                    "data": {
                        "nodeText": that.$t("mindmap.defaultMind.node1"),
                        "nodeImg": "",
                        "nodeLink": "",
                        "lineColor": "red",
                        "background-color": "rgb(255, 191, 215)",
                        "lock": false
                    }
                },
                {
                    "id": "uuid2",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.node2") + "</p>",
                    "expanded": true,
                    "parent": {
                        "id": "root"
                    },
                    "direction": "left",
                    "data": {
                        "nodeText": that.$t("mindmap.defaultMind.node2"),
                        "nodeImg": "",
                        "nodeLink": "",
                        "lineColor": "#0000ff",
                        "background-color": "rgb(139, 243, 255)",
                        "lock": false
                    }
                },
                {
                    "id": "uuid3",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.node3") + "</p>",
                    "expanded": true,
                    "parent": {
                        "id": "root"
                    },
                    "direction": "right",
                    "data": {
                        "nodeText": that.$t("mindmap.defaultMind.node3"),
                        "nodeImg": "",
                        "nodeLink": "",
                        "lineColor": "orange",
                        "background-color": "rgb(255, 238, 139)",
                        "lock": false
                    }
                },
                {
                    "id": "uuid4",
                    "topic": "<p>" + that.$t("mindmap.defaultMind.node4") + "</p>",
                    "expanded": true,
                    "parent": {
                        "id": "root"
                    },
                    "data": {
                        "nodeText": that.$t("mindmap.defaultMind.node4"),
                        "nodeImg": "",
                        "nodeLink": "",
                        "lineColor": "green",
                        "background-color": "rgb(211, 255, 139)",
                        "lock": false
                    },
                    "direction": "right"
                }
            ]
            initMindData.forEach((item) => {
                fluidMindData.set(item.id, JSON.stringify(item));
            })

        }

        //初始化先把isDeleting設為false
        fluidIsDeleting.set('data', false);

        fluidCoworkMode.set('data', JSON.stringify({
            "coworkMode": "edit",
            "openCowork": true,
        }));

        // 現在 attach 容器到 Fluid 服務
        data.fluidContainerId = await container.attach();
        console.log("容器 attach 完成，ID:", data.fluidContainerId);

        // 等待容器資料完全保存到 Fluid 服務
        console.log("等待容器資料保存完成，isDirty:", container.isDirty);
        if (container.isDirty) {
            console.log("容器有未保存的變更，等待 saved 事件...");
            await new Promise((resolve) => {
                container.once("saved", () => {
                    console.log("✅ 容器資料已完全保存到 Fluid 服務");
                    resolve();
                });
                // 設定超時保護（10秒）
                setTimeout(() => {
                    console.log("⏰ 等待 saved 事件超時，繼續執行");
                    resolve();
                }, 10000);
            });
        } else {
            console.log("✅ 容器無未保存變更，直接繼續");
        }

        const res = await api.mindmapAPI.createMindMap(data);

        sessionStorage.setItem("mindSubCreator", JSON.stringify({
            "id": stuSeatNumber.value,
            "name": stuName.value,
        }));

        // 跳轉前再次確保容器資料完全保存
        console.log("confirmToCreate - 跳轉前最終檢查，isDirty:", container.isDirty);
        if (container.isDirty) {
            console.log("confirmToCreate - 跳轉前發現未保存變更，等待 saved 事件...");
            await new Promise((resolve) => {
                container.once("saved", () => {
                    console.log("✅ confirmToCreate - 跳轉前容器資料已完全保存");
                    resolve();
                });
                // 設定超時保護（5秒）
                setTimeout(() => {
                    console.log("⏰ confirmToCreate - 跳轉前等待 saved 事件超時，繼續執行");
                    resolve();
                }, 5000);
            });
        } else {
            console.log("✅ confirmToCreate - 跳轉前無未保存變更，直接繼續");
        }

        // 跳轉前斷開當前容器避免下一個頁面連接錯誤
        try {
            if (container && typeof container.dispose === 'function') {
                container.dispose();
            }
        } catch (disposeError) {
            console.warn('容器斷開時發生錯誤，但不影響頁面跳轉:', disposeError);
        }

        router.push({
            path: '/MindMapClone',
            query: {
                id: res.id,
                openCowork: res.openCowork,
                fromTemplate: useTemplate.value ? 'true' : 'false'
            }
        });

    } catch (error) {
        console.error(error);
        $Message.error(that.$t("mindmap.mindmapHome.initializeFailed"));
    } finally {
        $q.loading.hide();
    }


};

const validateNumberInput = () => {
    let value = stuSeatNumber.value.replace(/[^0-9]/g, '');
    if (value.startsWith('0')) {
        value = value.substring(1);
    }
    if (value === '0') {
        value = '';
    }
    stuSeatNumber.value = value;
};

const resetSearch = async() => {
    search.value = "";
    mindmapList.value = [];
    const data = {
        cid: that.$route.query.cid,
        sortOrder: currentSortOrder.value,
        sortField: currentSortField.value,
        searchText: search.value,
    };
    const res = await api.mindmapAPI.getMindCollectById(data); //獲取本頁面資料
        mindmapList.value = res.mindmapList;
        mindcollectName.value = res.mindCollect.mindCollectName;
        mindCollect.value = res.mindCollect;
};

const searchMindMaps = async () => {
    console.log("search:", search.value);
    const data = {
        cid: that.$route.query.cid,
        sortOrder: currentSortOrder.value,
        sortField: currentSortField.value,
        searchText: search.value,
    };
    const res = await api.mindmapAPI.getMindCollectById(data); //獲取本頁面資料
        mindmapList.value = res.mindmapList;
        mindcollectName.value = res.mindCollect.mindCollectName;
        mindCollect.value = res.mindCollect;
};

// 重新獲取心智圖收集資料
const refreshMindCollectData = async () => {
    try {
        $q.loading.show({
            message: that.$t("mindmap.mindCollectPage.refreshing")
        });

        const data = {
            cid: that.$route.query.cid,
            sortOrder: currentSortOrder.value,
            sortField: currentSortField.value,
            searchText: search.value,
        };

        const res = await api.mindmapAPI.getMindCollectById(data);

        // 更新所有相關資料
        mindmapList.value = res.mindmapList;
        mindcollectName.value = res.mindCollect.mindCollectName;
        mindCollect.value = res.mindCollect;
        useTemplate.value = res.mindCollect?.useTemplate ?? false;
        currentOpenFRUsage.value = res.fluidRelayUsage;
        isReachMaxOpenFRUsage.value = currentOpenFRUsage.value >= maxOpenFRUsage.value;

        // 更新設置相關變數
        currentMindCollectName.value = res.mindCollect.mindCollectName;
        isMindCollectSubmitOpen.value = res.mindCollect.openSubmit || false;
        isMindCollectAllowView.value = res.mindCollect.allowViewOthers || false;
        currentMindMapURL.value = res.mindCollect.urlClipCode;

        $Message.success(that.$t("mindmap.mindCollectPage.refreshSuccess"));

    } catch (error) {
        console.error("重新獲取資料失敗:", error);
        $Message.error(that.$t("mindmap.mindCollectPage.refreshFailed"));
    } finally {
        $q.loading.hide();
    }
};
const openMindMapByID = async (mindmap) => {
    saveEnterMindHistoryLocal(mindmap);
    router.push({
        path: '/MindMapClone',
        query: {
            id: mindmap.id
        }
    });
};

const openCreateMindForm = () => {
    if(isReachMaxOpenFRUsage.value){
        $Message.error({
            content: that.$t("mindmap.reachMaxOpenFRUsage"),
            duration: 10,
            closable: true

        });
        return;
    }
    showMindForm.value = true;
};


const logout = () => {
    showAvatarMenu.value = false;
    if (isLogin.value) {
        api.main.logout().then(async () => {
            $Message.info(that.$t("mindmap.mindmapHome.logoutOK"));
            isLogin.value = false;
            localStorage.clear();
            sessionStorage.clear();
            router.push("/MindMapHome");
        });
    }
};

const getMyMindMapListBySort = async(field) => {
    if (currentSortField.value === field) {
        currentSortOrder.value = currentSortOrder.value === "asc" ? "desc" : "asc";
    } else {
        currentSortField.value = field;
        currentSortOrder.value = "asc";
    }
    let data = {
        cid: that.$route.query.cid,
        sortOrder: currentSortOrder.value,
        sortField: currentSortField.value,
        search: search.value,
    }
    const res = await api.mindmapAPI.getMindCollectById(data); //獲取本頁面資料
        mindmapList.value = res.mindmapList;
        mindcollectName.value = res.mindCollect.mindCollectName;
        mindCollect.value = res.mindCollect;
}

// 設置視圖模式（列表或網格）
const setView = (view) => {
    currentView.value = view;
     // 保存視圖偏好到 localStorage
     if (isLogin.value && profile.teammodelId) {
        localStorage.setItem(`mindmap_view_preference_${profile.teammodelId}`, view)
    }
};

const getMindMapImgUrl = (mindmap) => {
    try {
        if (mindMapStore.mindMapBlobsasurl && mindMapStore.mindMapBlobSas && mindmap?.snapshotUrl) {
            return 'url("' + mindMapStore.mindMapBlobsasurl + mindmap.snapshotUrl + '?' + mindMapStore.mindMapBlobSas + '")';
        } else {
            return `url("https://${location.host}/no-image.jpg")`;

        }
    } catch (err) {
        console.log(err);
    }
}



const saveEnterMindHistoryDB = async () => { 
    if (!isLogin.value || !profile.teammodelId) return; // 確保已登入且有用戶 ID

    const payload = {
        fromUser: {
            id: profile.teammodelId,
            name: profile.name,
        },
        mindmapHistories: Object.values(enterMindHistory).slice(0, 12), // 限制最多 12 筆
    };

    try {
        await api.mindmapAPI.saveMindClickHistory(payload);
    } catch (error) {
        console.error("Failed to update mind click history:", error);
    }
}

const saveEnterMindHistoryLocal = async (mindmap) => {
    if (!mindmap || !profile.teammodelId) return;
    const history = {
        id: mindmap.id,
        mindmapName: mindmap.mindmapName,
        snapshotUrl: mindmap.snapshotUrl ,
        timestamp: Date.now(),
        mindmapCreator: {
            id: mindmap.mindmapCreator.id,
            name: mindmap.mindmapCreator.name
        }
    };

    const storageKey = `enterMindHistory_${profile.teammodelId}`;
    let histories = JSON.parse(localStorage.getItem(storageKey) || '[]');
    
    // 移除相同 id 的舊記錄
    histories = histories.filter(h => h.id !== history.id);
    
    // 新增到開頭
    histories.unshift(history);
    
    // 限制最多保存 10 筆
    if (histories.length > 10) {
        histories = histories.slice(0, 10);
    }
    
    localStorage.setItem(storageKey, JSON.stringify(histories));
    Object.assign(enterMindHistory, histories);

    
    console.log("profile.value:",profile,"isCollectCreator.value:", isCollectCreator.value);
            
}

const handleGlobalKeyDown = (event) => {
        if (event.key === "Enter" && document.activeElement.tagName === "INPUT") {
            searchMindMaps();
        }
    };

    const initializeAuth = async () => {
    try {
        const res = await api.main.getTokenUnlogin();
        const exp = jwt_decode(res.auth_token);
        localStorage.setItem("auth_token", res.auth_token);
        localStorage.setItem("auth_token_expiry", exp.exp);
    } catch (error) {
        console.error("Error fetching auth token ", error);
    }
}

const getMindMapSas = async () => {
    try {
        const res = await api.mindmapAPI.getMindMapSas();
        // 提取 token 并存储到 mindMapStore
        const { token, expiresOn } = res;
        mindMapStore.setMindMapBlobSas(token); // 存储 token

        sessionStorage.setItem("mindmap_sas_expiry", expiresOn.toString());

        initMindMapBlob();
    } catch (error) {
        console.error("Error fetching MindMap SAS:", error);
        // 可以根据需要添加更多错误处理逻辑
    }
}

const initMindMapBlob = () => {
    if (mindMapStore.mindMapBlobsasurl) {
        const serviceClient = new BlobServiceClient(
            mindMapStore.mindMapBlobsasurl + "?" + mindMapStore.mindMapBlobSas
        );
        const containerClient = serviceClient.getContainerClient("");
        mindMapStore.setMindMapBlobContainerClient(containerClient);
    }
}

let tokenRefreshInterval = ref(null);

const startTokenRefreshInterval = () => {
    tokenRefreshInterval.value = setInterval(async () => {

        //檢查auth_token是否即將過期
        const authExpiry = localStorage.getItem("auth_token_expiry");
        const now = Date.now();
        const refreshThreshold = 10 * 1000; // 提前 10 秒刷新

        if (authExpiry) {
            const exp = authExpiry * 1000; // 将 exp 转换为毫秒
            if (exp - now < refreshThreshold) {
                localStorage.removeItem("auth_token");
                localStorage.removeItem("auth_token_expiry");
                // console.log("Auth Token is about to expire. Refreshing...");
                await initializeAuth();
            }
        }

        const sasExpiry = sessionStorage.getItem("mindmap_sas_expiry");

        if (sasExpiry) {
            const sasExpiryMs = Date.parse(sasExpiry); // 将 ISO 格式时间解析为时间戳（毫秒）
            // console.log("Current Time:", now, "SAS Expiry Time:", sasExpiryMs);

            if (sasExpiryMs - now < refreshThreshold) {
                console.log("SAS Token is about to expire. Refreshing...");
                await getMindMapSas();
            }
        }
    }, 60 * 1000); // 每分检查一次
}

watch(useTemplate, async (newValue) => {
    if(isCollectCreator.value){
    try {
        //寫入資料夾
        const collectData = {
            "cid": mindCollect.value.id,
            "useTemplate": newValue,
            "editor": {
                "id": profile.teammodelId,
                "name": profile.name,
            },
        }
        await api.mindmapAPI.updateMindCollect(collectData);
        
    } catch (error) {
        console.error("Failed to update mind collect:", error);
    }
}
});

// 監聽共用設置變化，提供即時反饋
watch(isMindCollectSubmitOpen, (newValue) => {
    if (mindCollect.value) {
        mindCollect.value.openSubmit = newValue;
    }
});

watch(isMindCollectAllowView, (newValue) => {
    if (mindCollect.value) {
        mindCollect.value.allowViewOthers = newValue;
    }
});


onMounted(async () => {
    // 監聽 HT webView 訊息（僅在 webview 環境下）
    if (window?.chrome?.webview) {
        window.chrome.webview.addEventListener("message", async function (e) {
            let msg = JSON.parse(e.data);
            console.log(msg, "收到HT webView訊息  在心智圖收集頁面");
            if (msg.action == "initialMindMap") {
                // 設定使用者認證資訊
                setupUserAuth(msg.parameters);
            }
        });
    }

    // 每 5 分鐘更新一次最近點閱到後端
    historyUpdateInterval = setInterval(saveEnterMindHistoryDB, 5 * 60 * 1000);
    
    try {
        await initializeAuth();
    } catch (error) {
        console.error("Error fetching auth token or mind map SAS:", error);
    }
    //初始化
    $q.loading.show();
    await getMindMapSas();
    startTokenRefreshInterval(); // 啟用檢查機制
    $q.loading.hide();

    // 檢查是否需要顯示設定頁面 (需要在載入資料後處理)
    const shouldShowSetting = that.$route.query.showSetting === 'true';

    document.addEventListener("keydown", handleGlobalKeyDown);

    const url = new URL(window.location.href);
    const queryParams = new URLSearchParams(url.search);
    const code = queryParams.get("code") || "";
    if (localStorage.getItem("profile") && localStorage.getItem("access_token")) {
        isLogin.value = true;
        profile.name = JSON.parse(localStorage.getItem("profile")).name;
        profile.picture = JSON.parse(localStorage.getItem("profile")).picture;
        profile.teammodelId = JSON.parse(localStorage.getItem("profile")).id || JSON.parse(localStorage.getItem("profile")).teammodelId;
        
         // 從 localStorage 讀取用戶視圖偏好
         const savedView = localStorage.getItem(`mindmap_view_preference_${profile.teammodelId}`);
        if (savedView) {
            currentView.value = savedView;
        }
    
    } else if (code) {
        isLogin.value = true;
        const res = await api.main.getToken();
        localStorage.setItem("id_token", res.id_token);  
      const decoded = jwt_decode(res.id_token);
        profile.name = decoded.name;
        profile.picture = decoded.picture;
        profile.teammodelId = decoded.sub;
        localStorage.setItem("access_token", res.access_token);
       localStorage.setItem("expires_in", res.expires_in);
        localStorage.setItem("profile", JSON.stringify(profile));

        // Remove the code parameter from the URL
        const url = new URL(window.location);
        url.searchParams.delete('code');
        url.searchParams.delete('state');
        url.searchParams.delete('clientId');
        window.history.replaceState({}, document.title, url.toString());
    }

    try {
        const data = {
            cid: that.$route.query.cid,
            sortOrder: currentSortOrder.value,
            sortField: currentSortField.value,
            search: search.value,
        };
           
        const res = await api.mindmapAPI.getMindCollectById(data); //獲取本頁面資料
        mindmapList.value = res.mindmapList;
        mindcollectName.value = res.mindCollect.mindCollectName;
        mindCollect.value = res.mindCollect;
        useTemplate.value = res.mindCollect?.useTemplate??false;
        currentOpenFRUsage.value = res.fluidRelayUsage;
        isReachMaxOpenFRUsage.value =  currentOpenFRUsage.value >= maxOpenFRUsage.value;

        // 初始化共用設置相關變數
        currentMindCollectName.value = res.mindCollect.mindCollectName;
        isMindCollectSubmitOpen.value = res.mindCollect.openSubmit || false;
        isMindCollectAllowView.value = res.mindCollect.allowViewOthers || false;
        
        // 設置URL
        currentMindMapURL.value = res.mindCollect.urlClipCode;
        
        // 檢查是否需要顯示設定頁面並執行簡碼檢查
        if (shouldShowSetting) {
            await openMindCollectSetting();
        }

        
        console.log("MindCollect data:", res);
        document.addEventListener("click", handleAvatarClickOutside);


        if(!mindCollect.value.openSubmit){
            $Message.info({
                content: that.$t("mindmap.mindCollectPage.submitClose"),
                duration: 5,
                closable: true,
            });
        }
        if(!mindCollect.value.allowViewOthers){
            $Message.info({
                content: that.$t("mindmap.mindCollectPage.viewClose"),
                duration: 5,
                closable: true,
            });
        }

        if(isLogin.value){
            isCollectCreator.value = mindCollect.value.creator.id === (JSON.parse(localStorage.getItem("profile"))?.id||JSON.parse(localStorage.getItem("profile"))?.teammodelId);
            
            // 載入歷史記錄
            const storageKey = `enterMindHistory_${profile.teammodelId}`;
            const histories = JSON.parse(localStorage.getItem(storageKey) || '[]');
            Object.assign(enterMindHistory, histories);

            
            console.log("profile.value:",profile,"isCollectCreator.value:", isCollectCreator.value);
            
        }

    } catch (error) {
        console.error("Error fetching MindCollect:", error);
    }
});
onBeforeUnmount(() => {
    document.removeEventListener("click", handleAvatarClickOutside);
    document.removeEventListener("keydown", handleGlobalKeyDown);

    // 清除定時器
    if (historyUpdateInterval) {
        clearInterval(historyUpdateInterval);
    }
    
    // 清除推送冷卻 timer
    if (cooldownTimer.value) {
        clearTimeout(cooldownTimer.value);
        cooldownTimer.value = null;
    }
});
</script>

<style lang="less" scoped>
@import "../assets/color.less";
@import "../assets/mindmapCollect.less";

</style>